/** @format */

import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TAPILicenseListSuccess } from "../../redux-modules/declarations/apis/licenses";
import apiClient from "../../utils/apiClient";

export const apiPeopleList = (): Promise<AxiosResponse<TAPILicenseListSuccess>> =>
  apiClient.get(API_ENDPOINTS.PEOPLE_LIST);
